const trackingParams = {
  brokerTransactionId: {
    key: 'BrokerTransactionId',
    alternativeKeys: [
      'tid',
      'coid',
      'fp',
      'regid',
      'tmtData',
      'Euroadsid',
      'at_gd',
      'ClickID'
    ],
    type: 'string'
  },
  brokerId: {
    key: 'BrokerId',
    type: 'int',
    alternativeKeys: [
      'brokerid',
      'brokerId',
      'Brokerid'
    ]
  },
  affId: {
    key: 'AffId',
    type: 'int',
    alternativeKeys: [
      'affid',
      'affId',
      'Affid'
    ]
  },
  adId: {
    key: 'AdId',
    type: 'int',
    alternativeKeys: [
      'adid',
      'adId',
      'Adid'
    ]
  },
  ad: {
    key: 'Ad',
    type: 'string'
  },
  urlId: {
    key: 'URLId',
    type: 'string'
  },
  campaignChannel: {
    key: 'CampaignChannel',
    type: 'string'
  },
  bidId: {
    key: 'BidId',
    alternativeKeys: [
      'bid-id',
      'bidId',
      'bidid'
    ],
    type: 'string'
  }
}

module.exports = { trackingParams }
